import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../common';
import { translate } from '../../common/translation/translate';
import { mediumMediaQuery, smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { LifePageIds } from './lifePageTypes';
import { LifeSubNavLinkItems } from './lifeSubNavLinkItems';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

interface LifePageSubNavigationProps {
    activePageId: string;
    isDesktop: boolean;
}

const mapStoreStateToProps = (storeState: any) => {
    const { pageId } = storeState?.appState?.appState || {};

    return {
        activePageId: pageId
    };
};

const mapDispatchToProps = {};

export const LifePageSubNavigation = withScreenSize(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    activePageId,
    isDesktop
}: LifePageSubNavigationProps) => {

    if (!isDesktop || activePageId?.toLocaleLowerCase() === LifePageIds.snowSkiDetail) {
        return null;
    }

    return (
        <Container>
            <LifePageSideNavTitle>
                {translate('lifestyles')}
            </LifePageSideNavTitle>
            <LifeSubNavLinkItems />
        </Container>
    );
})));

LifePageSubNavigation.displayName = 'LifePageSubNavigation';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 140px;
    @media ${mediumMediaQuery} {
        width: 175px;
    }
    @media ${smallMediaQuery} {
        width: 165px;
    }
`;

const LifePageSideNavTitle = styled.div`
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 600;
    padding: 10px 0px;
`;